"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@material-ui/core");
var _subscription = require("../../api/accessors/subscription");
var _Translated = _interopRequireDefault(require("../Translated"));
var _AlertMessage = _interopRequireDefault(require("../AlertMessage"));
var _SubscriptionForm = require("../SubscriptionForm");
var _plan = require("../../api/accessors/plan");
var _response = require("../../utils/response");
var _SubscriptionRadioItem = _interopRequireDefault(require("../SubscriptionRadioItem"));
var _dateTime = require("../../utils/dateTime");
var _api = require("../../api");
var _eventEmitter = require("../../utils/eventEmitter");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const useStyles = (0, _core.makeStyles)({
  confirmPaymentButton: {
    '&.MuiLink-underlineNone': {
      textDecoration: 'none'
    }
  }
});
const SubscriptionItem = _ref => {
  let {
    isLegacy,
    hasNoPaymentMethods = false,
    subscription,
    editable = true,
    unpaidInvoiceUrl,
    plan: passedPlan,
    plainText = false,
    onSubscriptionUpdated: passedOnSubscriptionUpdated,
    account,
    ...props
  } = _ref;
  const classes = useStyles(props);
  const [editMode, setEditMode] = (0, _react.useState)(false);
  const [requestError, setRequestError] = (0, _react.useState)(null);
  const [requestInProgress, setRequestInProgress] = (0, _react.useState)(false);
  const plan = passedPlan || (0, _subscription.getPlan)(subscription);
  const subscriptionRenewalHasBeenCancelled = (0, _subscription.getCancelAtPeriodEnd)(subscription) || (0, _subscription.getCancelAt)(subscription);
  const onSubscriptionUpdated = updatedSubscription => {
    setEditMode(false);
    passedOnSubscriptionUpdated(updatedSubscription);
  };
  const onCancel = () => setEditMode(false);
  const onChange = async params => {
    setRequestError(null);
    setRequestInProgress(true);
    const isActivationForLegacyUser = isLegacy && params.action === 'activate';
    if (isActivationForLegacyUser) {
      _eventEmitter.eventEmitter.emit(_eventEmitter.OPEN_SUBSCRIPTION_POPUP);
    }
    const [error, response] = await (0, _api.changeSubscriptionActivation)((0, _subscription.getId)(subscription), params);
    if (!error && response) {
      onSubscriptionUpdated(response);
    } else {
      setRequestError(error);
    }
    setRequestInProgress(false);
  };
  const renderLabel = () => /*#__PURE__*/_react.default.createElement(_core.Box, {
    display: "flex",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_core.Box, null, plainText ? /*#__PURE__*/_react.default.createElement(_core.Typography, null, (0, _plan.getName)(plan)) : (0, _plan.getName)(plan), subscription && /*#__PURE__*/_react.default.createElement(_core.Typography, {
    variant: "body2",
    color: "textSecondary"
  }, subscriptionRenewalHasBeenCancelled && /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "subscription_will_be_deactivated",
    values: {
      date: (0, _dateTime.formattedDate)((0, _dateTime.fromTimestamp)((0, _subscription.getCurrentPeriodEnd)(subscription)))
    }
  }))), editable && /*#__PURE__*/_react.default.createElement(_core.Box, {
    marginLeft: 1
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    disabled: requestInProgress,
    onClick: () => onChange({
      action: subscriptionRenewalHasBeenCancelled ? 'activate' : 'deactivate'
    })
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: subscriptionRenewalHasBeenCancelled ? 'activate' : 'deactivate'
  })), /*#__PURE__*/_react.default.createElement(_core.Button, {
    disabled: requestInProgress,
    onClick: () => setEditMode(true)
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "edit"
  }))));
  const pastDueMessage = /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "subscription_past_due"
  });
  const incompleteMessage = /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "subscription_incomplete"
  });
  if (editMode) {
    if (isLegacy || hasNoPaymentMethods) {
      _eventEmitter.eventEmitter.emit(_eventEmitter.OPEN_SUBSCRIPTION_POPUP);
      setEditMode(false);
      return null;
    }
    return /*#__PURE__*/_react.default.createElement(_SubscriptionForm.SubscriptionForm, {
      onCancel: onCancel,
      subscription: subscription,
      onSuccess: onSubscriptionUpdated,
      submitButtonText: /*#__PURE__*/_react.default.createElement(_Translated.default, {
        id: "update"
      }),
      buttonsContainerProps: {
        mt: 2
      },
      noMargins: true,
      showTotalPrice: false
    });
  }
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, requestError && /*#__PURE__*/_react.default.createElement(_core.Box, {
    mb: 3
  }, /*#__PURE__*/_react.default.createElement(_AlertMessage.default, {
    text: (0, _response.getErrorMessage)(requestError)
  })), (0, _subscription.isSubscriptionPastDue)(subscription) && /*#__PURE__*/_react.default.createElement(_core.Box, {
    mb: 3
  }, /*#__PURE__*/_react.default.createElement(_AlertMessage.default, {
    variant: "filled",
    severity: "warning",
    text: pastDueMessage
  })), (0, _subscription.isSubscriptionIncomplete)(subscription) && /*#__PURE__*/_react.default.createElement(_core.Box, {
    mb: 3
  }, /*#__PURE__*/_react.default.createElement(_AlertMessage.default, {
    variant: "filled",
    severity: "warning",
    text: unpaidInvoiceUrl ? /*#__PURE__*/_react.default.createElement(_Translated.default, {
      id: "unpaid_invoice"
    }) : incompleteMessage
  }), unpaidInvoiceUrl && /*#__PURE__*/_react.default.createElement(_core.Box, {
    mt: 2
  }, /*#__PURE__*/_react.default.createElement(_core.Link, {
    target: "_blank",
    underline: "none",
    href: unpaidInvoiceUrl,
    className: classes.confirmPaymentButton
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    variant: "contained",
    color: "primary"
  }, /*#__PURE__*/_react.default.createElement(_Translated.default, {
    id: "confirm_payment"
  }))))), plainText && renderLabel(), !plainText && /*#__PURE__*/_react.default.createElement(_SubscriptionRadioItem.default, _extends({
    checked: true,
    label: renderLabel(),
    plan: (0, _subscription.getPlan)(subscription),
    disabled: requestInProgress,
    style: {
      cursor: 'inherit'
    }
  }, props)));
};
var _default = exports.default = SubscriptionItem;